module.exports = __webpack_public_path__ + "img/three3Green.8de5fb05.jpg";